import { citiesSlice } from "./citiesSlice";
import * as actions from "./citiesActions";
import * as selectors from "./citiesSelectors";

export { actions };
export { selectors };
export default citiesSlice.reducer;
